import { Text } from "@chakra-ui/react";
import type { SbEditableComponentProps } from "types/storyblok";
import type { ParagraphProps } from "./Paragraph.d";

const Paragraph = ({ children, styles, sbEditable }: SbEditableComponentProps<ParagraphProps>) => (
  <Text sx={styles} {...sbEditable}>
    {children}
  </Text>
);

export default Paragraph;
